var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoginPageLayoutCard',[_c('LoginCardHeader'),_c('LoginForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }